<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentFile.attributes"
          headline="Edit File"
          :errors="errors"
          :company-id="contentFile.attributes.company_id"
          :content-file-categories="contentFileCategories"
          :edit="true"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentFiles/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentFile: null,
      contentFileCategories: null,

      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-files/' + this.$route.params.contentFileId),
        http.get('/api/v2/content-file-categories', {'filter[portal_id]': this.portal.id})
      ]).then(responses => {
        this.contentFile = responses[0].data.data

        this.contentFileCategories = responses[1].data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-files/' + this.$route.params.contentFileId, data)
          .then(response => {
            notify.success('The content file was saved')

            this.contentFile = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
